import {
  UserBookingDetailsQuery,
  WayPointType,
} from '@website/types/graphqlOperations';
import MeetPoint from './utils/MeetPoint';

type Props = {
  spaces: Pick<UserBookingDetailsQuery['booking']['spaces'][0], 'guest'>[];
  userID: string;
  booking: Pick<UserBookingDetailsQuery['booking'], 'trip' | 'group'>;
};

export default function MeetPoints({ spaces, userID, booking }: Props) {
  // If the trip has a single meetPoint, just show that one
  const allTripMeetPoints = booking.trip.wayPoints.items.filter(
    (wayPoint) => wayPoint.type === WayPointType.MeetPoint,
  );
  if (allTripMeetPoints.length === 1) {
    return (
      <MeetPoint meetPoint={allTripMeetPoints[0]} start={booking.group.start} />
    );
  }

  // Otherwise we need to find which meet point the specific user has selected in their trip form
  const guestSpace = spaces.find((space) => space.guest?.userID === userID);
  const guestMeetPoint = guestSpace?.guest.tripForm?.meetPoint;

  // Don't show any if the guest hasn't selected theirs yet
  if (!guestMeetPoint) return null;

  return <MeetPoint meetPoint={guestMeetPoint} start={booking.group.start} />;
}
